import { Editor, Range } from 'slate';
import { findLink } from './findLink.mjs';
import { getText } from '../../../../queries/getText.mjs';

function getLinkAndText(editor) {
  const linkEntry = findLink(editor);
  const {
    selection
  } = editor;
  if (!linkEntry || !selection) {
    return {
      link: null,
      text: getText(editor, {
        at: selection,
        expandToClosestWord: true
      })
    };
  }
  const [link, path] = linkEntry;
  const linkRange = Editor.range(editor, path);
  const {
    anchor,
    focus
  } = selection;
  const selectionIsWithinLink = Range.includes(linkRange, anchor) && Range.includes(linkRange, focus);
  const text = getText(editor, {
    at: selectionIsWithinLink ? linkRange : selection
  });
  return {
    link: link,
    text
  };
}

export { getLinkAndText };
